import HeroSection from './components/HeroSection';
import PhilosophySection from './components/PhilosophySection';
import PrinciplesSection from './components/PrinciplesSection';
import InnovationSection from './components/InnovationSection';
import CapabilitySection from './components/CapabilitySection';
import ContactFooter from './components/ContactFooter';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <HeroSection />
      <PhilosophySection />
      <PrinciplesSection />
      <InnovationSection />
      <CapabilitySection />
      <ContactFooter />
    </main>
  );
}